import { Component, Inject } from '@angular/core';
import { IotaModalOptions, IotaModalSize, MAT_DIALOG_DATA, MatDialogRef } from '@iota/iota-ui-components';

export interface ValidationFailedDialogData {
    title: string;
    text: string;
}

@Component({
    standalone: false,
    selector: 'app-dialog-validation-failed',
    templateUrl: './dialog-validation-failed.component.html',
    styleUrls: ['./dialog-validation-failed.component.scss']
})
export class DialogValidationFailedComponent {
    public modalOptions: Partial<IotaModalOptions> = {
        size: IotaModalSize.SMALL,
        showToggleFullScreenButton: false
    };

    constructor(
        public dialogRef: MatDialogRef<DialogValidationFailedComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ValidationFailedDialogData
    ) {}

    close() {
        this.dialogRef.close();
    }
}
